import styled from 'styled-components';
import CommonColumn from '../../common/Column';

const Column = styled(CommonColumn)`
    align-content: center;
    width: 98px;
`;

export default Column;
